import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export const ProtectedRoute = ({ children, adminOnly = false, staffOnly = false }) => {
  const { isAuthenticated, isAdmin, user, loading, showStaffFeatures, canUseGodMode } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!isAuthenticated) {
    // Preserve the intended destination so /login can send the user back
    // after auth (critical for PWA cold-launches at /staff-mobile or /mobile).
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  if (adminOnly) {
    // Allow admins and rok.kobal@europacific.com to access admin-only routes
    const isRokKobal = user?.email?.toLowerCase() === "rok.kobal@europacific.com";
    if (!isAdmin && !isRokKobal) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  // Staff-only routes: Allow if user is staff OR if God Mode allows staff view
  if (staffOnly) {
    const isStaff = user?.user_type === "europacific_staff";
    const godModeAllowsStaff = canUseGodMode && showStaffFeatures();
    
    if (!isStaff && !godModeAllowsStaff) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
};
